import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Buttons, FlexContainer, ModalContext, Modals, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import CustomTransition from 'Components/CustomTransition';
import OneColLayout from 'Components/Layouts/OneColLayout';
import { routes } from 'Constants/routes';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import * as Styled from '../styles';

const InstantRefundPromote = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  const { showModal, hideModal } = useContext(ModalContext);
  const infoSubscription = useSelector(routeStateSelector);

  const openModal = (): void => {
    showModal({
      comp: (
        <Modals.Centered
          title={t('Filing.Flex.InstantRefund.Title')}
          description={t('Filing.Flex.InstantRefund.Description')}
          urlImage={`${TAXDOWN_ASSETS_DOMAIN}/illustrations/default/done_s.png`}
          primaryButton={{
            label: t('Filing.Flex.InstantRefund.CTA'),
            onClick: () => {
              hideModal();

              history.push(routes.FILING_INSTANT_REFUND_ACTIVE, {
                result: infoSubscription?.taxReturnResult,
              });
            },
          }}
          secondaryButton={{
            label: t('Filing.Flex.InstantRefund.Cancel.CTA'),
            onClick: () => {
              hideModal();
              history.push(routes.FILING_CLABE_FLEX);
            },
          }}
          onClose={hideModal}
          hasClose
          maxSize="S"
        />
      ),
    });
  };

  return (
    <OneColLayout>
      <CustomTransition start>
        <Styled.Container direction="column" align="center" fullWidth fullHeight>
          <Styled.Header align="center" justify="center">
            <img
              src={`${TAXDOWN_ASSETS_DOMAIN}/illustrations/default/money_s.png`}
              alt="instant-refund"
            />
          </Styled.Header>
          <Styled.ContentContainer direction="column">
            <FlexContainer direction="column" align="center" gap="dimension_16" justify="center">
              <Text type="headline" size="S_L_S" color="dark" align="center">
                {t('Filing.instant.refund.title')}
              </Text>
              <Text type="paragraphs" size="S_M_S" color="grey" align="center">
                {t('Filing.instant.refund.subtitle')}
              </Text>
            </FlexContainer>
            <Styled.ButtonsContainer justify="center" gap="dimension_24" fullWidth>
              <Buttons.Tiny label={t('InstantRefund.promote.cancel')} onClick={openModal} />
              <Buttons.Classic
                size="m"
                mode="success"
                label={t('InstantRefund.promote.label')}
                onClick={() =>
                  history.push(routes.FILING_INSTANT_REFUND_ACTIVE, {
                    result: infoSubscription?.taxReturnResult,
                  })
                }
              />
            </Styled.ButtonsContainer>
          </Styled.ContentContainer>
        </Styled.Container>
      </CustomTransition>
    </OneColLayout>
  );
};

export default InstantRefundPromote;
